import { render, staticRenderFns } from "./rfq-tab-compare.vue?vue&type=template&id=24d281d1"
import script from "./rfq-tab-compare.vue?vue&type=script&lang=js"
export * from "./rfq-tab-compare.vue?vue&type=script&lang=js"
import style0 from "./rfq-tab-compare.vue?vue&type=style&index=0&id=24d281d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports